import { last } from 'ramda';
import { IGeocodeForSearchResponse, IDistrict } from 'shared/types/geoSuggest';

export function getDistrict({
  isParsed,
  microDistricts = [],
  details = [],
}: IGeocodeForSearchResponse): IDistrict | undefined {
  if (isParsed) {
    if (microDistricts.length > 0) {
      return {
        name: microDistricts[0].fullName || '',
        id: microDistricts[0].id,
      };
    }

    const detail = last(details);

    if (detail && detail.geoType === 'District') {
      return {
        name: detail.fullName || '',
        id: detail.id,
      };
    }
  }

  return undefined;
}
